module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/traev/Sites/btt/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main